import { render, staticRenderFns } from "./DataTableAlternate.vue?vue&type=template&id=39e7b142&"
import script from "./DataTableAlternate.vue?vue&type=script&lang=js&"
export * from "./DataTableAlternate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports